import { escapeRegExp } from 'lodash';
import { Pipe, PipeTransform } from '@angular/core';
import { InnerHtmlPipe } from 'shared/components/canned-message-panel/filters/inner-html.pipe';

@Pipe({
  name: 'appHighlight'
})
export class HighlightPipe implements PipeTransform {
  private static readonly InnerHtmlPipe = new InnerHtmlPipe();

  transform(str: string, pattern: string) : string {
    if (!pattern || !str || !str.match) {
      return str;
    }
    const regexp = new RegExp('(' + escapeRegExp(pattern) + ')', 'gi');
    const strParts = str.match(/([^<>]+|<[^>]*>)/gi);
    for (let i = 0, l = strParts.length; i < l; i++) {
      if (strParts[i][0] !== '<') {
        strParts[i] = HighlightPipe.InnerHtmlPipe.transform(strParts[i]).replace(regexp, '<span class="bc-highlight">$1</span>');
      }
    }

    return strParts.join('');
  }
}
